var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 204 165",
    style: {
      enableBackground: "new 0 0 204 165"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00A76B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.2,8c-1.9,1.8-2.9,2.9-4,3.8c-45,38.9-80.2,85.2-106,138.7c-0.4,0.9-0.6,2.1-1.4,2.6 c-2.3,1.7-4.8,4.4-7.1,4.3c-2.6-0.1-5.8-2.4-7.3-4.7c-3-4.5-4.8-9.8-7.4-14.7c-12.3-22.9-30-40.5-52.4-53.6c-1.5-0.9-3-1.9-5.1-3.2 c6.8-1.9,12.9-3.8,19-5.1c2.1-0.4,4.6,0.3,6.7,1c17.5,6.1,33.3,15,45.9,29.4c6.6-8.1,13-16,19.5-23.7c21.6-25.7,44.9-49.6,72.4-69.2 c5.7-4.1,11.3-6.7,18.4-5.8C191.9,8.2,194.4,8,198.2,8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check_green.3c078f832fa714fdf4e00d52eded77ac.svg";
export { ForwardRef as ReactComponent };